/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class DocumentsApiConfiguration {
  rootUrl: string = '/';
}

/**
 * Parameters for `DocumentsApiModule.forRoot()`
 */
export interface DocumentsApiConfigurationParams {
  rootUrl?: string;
}
